export default __webpack_public_path__ + "static/media/forestly-expl-intro_EN.d2032d2e.png";